import React from 'react';
import { Breadcrumbs, Button, Typography } from '@mui/material';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';

export default function ProjectRepositoryBreadcrumb({ items = [], onNavigate }) {
    return (
        <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} aria-label="Document location">
            {items.map((item, index) => {
                const last = index === items.length - 1;
                return last ? (
                    <Typography key={item.path || 'root'} color="text.primary" sx={{ fontWeight: 800 }}>
                        {item.name}
                    </Typography>
                ) : (
                    <Button
                        key={item.path || 'root'}
                        size="small"
                        color="inherit"
                        onClick={() => onNavigate(item.path)}
                        sx={{ minWidth: 0, px: 0.5, textTransform: 'none' }}
                    >
                        {item.name}
                    </Button>
                );
            })}
        </Breadcrumbs>
    );
}